import { render, staticRenderFns } from "./CartExtra.vue?vue&type=template&id=640861d9&"
import script from "./CartExtra.vue?vue&type=script&lang=js&"
export * from "./CartExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports